module.exports = __webpack_public_path__ + "static/media/Daily Emails for EMAIL IMPORT.178e0be9.png";